import { useEffect, useState } from 'react'
import { Box, Button, Icon, IconButton, Stack, Tooltip, Typography, useTheme } from '@mui/material'

const DEFAULT_MORE_INFO_TEXT = 'מידע נוסף'
const CLOSE_TEXT = 'סגירה'
const PREVIOUS_TEXT = 'הקודם'
const NEXT_TEXT = 'הבא'

const MORE_INFO_STYLE = {
    color: 'inherit',
    textDecoration: 'underline',

    '&:hover, &:focus, &:focus:not(:hover)': {
        color: 'inherit',
        textDecoration: 'underline',
    },
}

export default function AnnouncementBar({ announcements = [], onMoreInfo, onShowing }) {
    const [dismissed, setDismissed] = useState(false)
    const [index, setIndex] = useState(0)
    const [trigger, setTrigger] = useState(undefined)

    const rtl = useTheme().direction === 'rtl'
    const towardsPrevious = rtl ? 'chevron_right' : 'chevron_left'
    const towardsNext = rtl ? 'chevron_left' : 'chevron_right'

    useEffect(() => {
        setIndex(0)
        setTrigger(undefined)
    }, [announcements])

    const showing = dismissed ? null : announcements[Math.min(index, announcements.length - 1)] ?? null

    useEffect(() => {
        onShowing?.(showing ?? null, trigger)
    }, [showing, trigger])

    if (showing == null) {
        return null
    }

    const current = showing
    const canNavigate = announcements.length > 1
    const moreInfoText = current.moreInfoText || DEFAULT_MORE_INFO_TEXT

    const moveBy = (step, movedBy) => {
        setIndex((previous) => (previous + step + announcements.length) % announcements.length)
        setTrigger(movedBy)
    }

    return (
        <Box
            sx={({ borders, palette }) => ({
                width: '100%',
                mt: 1,
                mb: 1,
                px: 2,
                py: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: borders.borderRadius.xl,
                backgroundColor: palette.info.main,
                color: palette.white.main,
            })}
        >
            <Box sx={{ flex: '1 1 0' }} />

            <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body2" sx={{ color: 'inherit' }}>{current.caption}</Typography>

                <Button
                    sx={MORE_INFO_STYLE}
                    onClick={() => onMoreInfo?.(current.documentId)}
                >
                    {moreInfoText}
                </Button>
            </Stack>

            <Stack
                direction="row"
                spacing={0.5}
                alignItems="center"
                justifyContent="flex-end"
                sx={{ flex: '1 1 0' }}
            >
                {canNavigate && (
                    <>
                        <Tooltip title={PREVIOUS_TEXT}>
                            <IconButton
                                aria-label={PREVIOUS_TEXT}
                                sx={{ color: 'inherit' }}
                                onClick={() => moveBy(-1, 'previous')}
                            >
                                <Icon>{towardsPrevious}</Icon>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={NEXT_TEXT}>
                            <IconButton
                                aria-label={NEXT_TEXT}
                                sx={{ color: 'inherit' }}
                                onClick={() => moveBy(1, 'next')}
                            >
                                <Icon>{towardsNext}</Icon>
                            </IconButton>
                        </Tooltip>
                    </>
                )}

                <Tooltip title={CLOSE_TEXT}>
                    <IconButton
                        aria-label={CLOSE_TEXT}
                        sx={{ color: 'inherit' }}
                        onClick={() => setDismissed(true)}
                    >
                        <Icon>close</Icon>
                    </IconButton>
                </Tooltip>
            </Stack>
        </Box>
    )
}
